import { apiAgents } from "../../axios/apiAgentsInstance";

export const getAgentByEmail = async ({ email, token }) => {
	if (!email) throw new Error('email is required');
	if (!token) throw new Error('token is required');

	try {
		const url = `/email/${encodeURIComponent(email)}`;
		const { data } = await apiAgents.get(url, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		// API returns { agent, customer }
		return data?.agent || null;
	} catch (error) {
		console.error('Error fetching agent by email:', error);
		throw error;
	}
};

export const getAgentById = async ({ id_customer, id_agent, token }) => {
	if (!id_customer) throw new Error('id_customer is required');
	if (!id_agent) throw new Error('id_agent is required');
	if (!token) throw new Error('token is required');

	try {
		const { data } = await apiAgents.get(`/${id_customer}`, {
			params: { id_agent },
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return data?.agent || null;
	} catch (error) {
		console.error('Error fetching agent by id:', error);
		throw error;
	}
};

export const getAgentsWithFilters = async ({
	id_customer,
	token,
	role = null,
	status = null,
	search = null,
	page = 1,
	limit = 10,
	offset = 0,
}) => {
	if (!id_customer) throw new Error('id_customer is required');
	if (!token) throw new Error('token is required');

	try {
		const params = {
			limit,
			offset,
		};

		if (role && role !== 'todos') {
			params.role = role;
		}

		if (status && status !== 'todos') {
			// Convert "Activo"/"Inactivo" to boolean
			params.is_active = status === 'Activo';
		}

		if (search) {
			params.search = search;
		}

		const { data } = await apiAgents.get(`/list/${id_customer}`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return {
			items: data?.items || [],
			offset: data?.offset || offset,
			count: data?.count || 0,
			limit: data?.limit || limit,
			total: data?.count || 0,
		};
	} catch (error) {
		console.error('Error fetching agents with filters:', error);
		throw error;
	}
};